module.exports = __webpack_public_path__ + "img/logo-log-in.2b27b82f.png";